import type { Address } from '~~/types/commercetools';
import { CheckoutClientType } from '~~/types/checkout/formData/checkoutClientType';
import { SELF_DECLARATION_LABEL } from '~~/constants/commerceTools';
import { extractCustomField } from '~~/helpers/customFields';
import { isSelfDeclaration } from '~~/helpers/cart/customFields';
import type { SelfDeclaration } from '~~/helpers/cart/customFields';

const CLIENT_TYPE_BY_SELF_DECLARATION: Record<SelfDeclaration, CheckoutClientType> = {
  company: CheckoutClientType.COMPANY,
  individual: CheckoutClientType.PRIVATE,
};

// A draft holds the value JSON-encoded, while a fetched address holds it plain.
const parseSelfDeclaration = (value: string): string => {

  try {

    const parsedValue = JSON.parse(value);

    return typeof parsedValue === 'string' ? parsedValue : value;

  } catch {

    return value;

  }

};

export const getClientTypeFromAddress = (address: Maybe<Partial<Address>>): CheckoutClientType | null => {

  const rawSelfDeclaration = address && extractCustomField(address, SELF_DECLARATION_LABEL);

  if (!rawSelfDeclaration) {

    return null;

  }

  const selfDeclaration = parseSelfDeclaration(rawSelfDeclaration);

  return isSelfDeclaration(selfDeclaration) ? CLIENT_TYPE_BY_SELF_DECLARATION[selfDeclaration] : null;

};
